export type DemoTourMode = "free" | "tour";

export interface DemoTourState {
  readonly mode: DemoTourMode;
  readonly paused: boolean;
}

export type DemoTourEvent =
  | { type: "start-tour" }
  | { type: "exit-tour" }
  | { type: "toggle-pause" }
  | { type: "stage-interaction" };

export const INITIAL_TOUR_STATE: DemoTourState = { mode: "free", paused: false };

/**
 * O modo da demo é máquina de estado pura: o relógio do roteiro fica no
 * `use-demo-player`, e aqui só se decide quem manda nele. Assim as regras do
 * modo — sobretudo "clicar no palco devolve o controle" — têm teste sem DOM.
 */
export function demoTourReducer(
  state: DemoTourState,
  event: DemoTourEvent,
): DemoTourState {
  switch (event.type) {
    case "start-tour":
      return { mode: "tour", paused: false };
    case "exit-tour":
      return INITIAL_TOUR_STATE;
    case "toggle-pause":
      return state.mode === "tour" ? { ...state, paused: !state.paused } : state;
    case "stage-interaction":
      return state.mode === "tour" ? INITIAL_TOUR_STATE : state;
  }
}

/** O player só avança sozinho quando o tour está tocando. */
export function isTourPlaying(state: DemoTourState): boolean {
  return state.mode === "tour" && !state.paused;
}
